import { createContext, useContext } from 'react';

/**
 * True for content rendered inside a settings layout. The layout's rail and
 * the breadcrumb already name the page, so section chrome can drop its title
 * there and keep the description.
 */
export const SettingsShellContext = createContext(false);

export function useInSettingsShell(): boolean {
  return useContext(SettingsShellContext);
}
